import { SetStateAction, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Layout from "../../components/Layout/Layout";
import {
  Activity,
  Braces,
  CalendarEvent,
  Cpu,
  PersonFill,
} from "react-bootstrap-icons";
import { getApplicationVersionSigning } from "../../api/signingApi";
import ErrorMessage from "../../components/ErrorMessage/ErrorMessage";
import { COLUMN_TYPE, LAYOUT_TYPE } from "../../constants";
import {
  getDateAsIsoString,
  getTextWithCapitalizedFirstLetter,
} from "../../helpers/textHelper";
import FileContainer from "../../components/FileContainer/FileContainer";
import List from "../../components/List/List";

export default function Signing() {
  const [signing, setSigning] = useState<any>();
  const [fileDownloadError, setFileDownloadError] = useState("");
  const [error, setError] = useState("");
  const params = useParams();
  const { t } = useTranslation();

  useEffect(() => {
    getApplicationVersionSigning(
      Number(params.signingId),
      (responseData: SetStateAction<any>) => {
        setSigning(responseData);
      },
      (errorText: React.SetStateAction<string>) => {
        setError(errorText);
      }
    );
  }, [params.signingId]);

  if (error) {
    return <ErrorMessage text={error} className="m-5" />;
  }

  return (
    <>
      {fileDownloadError && (
        <ErrorMessage text={fileDownloadError} inContainer={true} />
      )}
      {signing ? (
        <Layout
          type={LAYOUT_TYPE.INNER_PAGE}
          backButtonTitle="Version"
          infoFields={[
            {
              icon: <Cpu />,
              title: signing.processor,
            },
            {
              icon: <Braces />,
              title: t(getTextWithCapitalizedFirstLetter(signing.environment)),
            },
            {
              icon: <PersonFill />,
              title: signing.createdBy,
            },
            {
              icon: <CalendarEvent />,
              title: getDateAsIsoString(signing.createdOn),
            },
            {
              icon: <Activity />,
              title: t(getTextWithCapitalizedFirstLetter(signing.status)),
            },
          ]}
        >
          {signing.processingResultFiles &&
            signing.processingResultFiles.length > 0 && (
              <>
                <h4 className="ps-114-rem pt-228-rem pb-114-rem m-0 font-weight-600 text-gray-36">
                  {t("Files")}
                </h4>
                {signing.processingResultFiles.map((file: any, i: number) => (
                  <FileContainer
                    key={i}
                    file={file}
                    onFetchError={(errorText: SetStateAction<string>) => {
                      setError(errorText);
                    }}
                    onDownloadError={(errorText: SetStateAction<string>) => {
                      setFileDownloadError(errorText);
                    }}
                  />
                ))}
              </>
            )}
          {signing.processingAttempts && signing.processingAttempts.length > 0 && (
            <>
              <h4 className="ps-114-rem pt-228-rem pb-114-rem m-0 font-weight-600 text-gray-36">
                {t("Processing Attempts")}
              </h4>
              <List
                columns={[
                  {
                    propertyName: "errorCode",
                    headerName: "Error Code",
                    type: COLUMN_TYPE.TEXT,
                  },
                  {
                    propertyName: "errorMessage",
                    headerName: "Error Message",
                    type: COLUMN_TYPE.TEXT,
                  },
                  {
                    propertyName: "status",
                    headerName: "Status",
                    type: COLUMN_TYPE.STATUS,
                  },
                  {
                    propertyName: "createdOn",
                    headerName: "Created On",
                    type: COLUMN_TYPE.DATE,
                    optional: true,
                  },
                ]}
                items={signing.processingAttempts}
              />
            </>
          )}
        </Layout>
      ) : (
        <Layout type={LAYOUT_TYPE.INNER_PAGE_LOADING} />
      )}
    </>
  );
}
